/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 9/1/13
 * Time: 4:26 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var DropdownItemModel = Backbone.Model.extend({
        defaults : {
            key : "",
            value : "",
            icon: "",
            cssClass: "",
            tooltipTitle: "", //tooltip
            tooltipPosition: "" //tooltip position
        }
    });

    return DropdownItemModel;
});
